import { isFriday, isMonday, isSaturday, isSunday, isThursday, isTuesday, isWednesday } from 'date-fns'

type WeekDays = string[]

export function validateDateIsOneOfThisWeekDays(date?: string, weekDays?: WeekDays): boolean {
  if (!date || !weekDays) return true

  const [day, month, year] = date.split('/').map(Number)

  const dateObject = new Date(year, month - 1, day)

  const isValidDate = weekDays.some((weekDay) => {
    if (weekDay === 'Segunda') return isMonday(dateObject)
    if (weekDay === 'Terça') return isTuesday(dateObject)
    if (weekDay === 'Quarta') return isWednesday(dateObject)
    if (weekDay === 'Quinta') return isThursday(dateObject)
    if (weekDay === 'Sexta') return isFriday(dateObject)
    if (weekDay === 'Sábado') return isSaturday(dateObject)
    if (weekDay === 'Domingo') return isSunday(dateObject)

    return false
  })

  return isValidDate
}
